import { Breadcrumb, Space, Typography } from 'antd';
import { ItemType } from 'antd/lib/breadcrumb/Breadcrumb';

import styled, { StyledProp, css } from '@/styled';

type BreadcrumbItem = ItemType[];

interface PageTitleProps extends StyledProp {
  title: React.ReactNode;
  breadcrumbItems?: BreadcrumbItem;
  endContent?: React.ReactNode;
}

const PageTitle = ({ title, breadcrumbItems, endContent, ...rest }: PageTitleProps) => {
  const hasBreadcrumbItems = breadcrumbItems && breadcrumbItems.length > 0;

  return (
    <Space {...rest} direction='vertical' size={24}>
      <Space className='page-title-container'>
        <div className='page-title-rightContent'>
          {hasBreadcrumbItems && <Breadcrumb items={breadcrumbItems} />}

          <Typography.Title level={2} ellipsis>
            {title}
          </Typography.Title>
        </div>

        {endContent && <div className='page-title-leftContent'>{endContent}</div>}
      </Space>
    </Space>
  );
};

export default styled(PageTitle, { label: 'title-pages' })(
  ({ theme }) => css`
    display: flex;
    margin-bottom: ${theme.space.pxToRem(24)};

    .page-title-container {
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      width: 100%;

      ${theme.breakpoints.down('sm')} {
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
      }

      .page-title-rightContent {
        display: flex;
        flex-direction: column;

        .ant-breadcrumb {
          margin-bottom: 24px;

          .ant-breadcrumb-link {
            font-size: ${theme.space.pxToRem(14)};
          }
        }

        ${theme.breakpoints.down('md')} {
          h2.ant-typography {
            font-size: ${theme.space.pxToRem(24)};
          }
        }
      }

      .page-title-leftContent {
        display: flex;
        align-items: center;
      }
    }

    h2.ant-typography {
      margin-bottom: 0;
      color: ${theme.colorTextBase};
    }
  `
);
